var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6184 5.392C14.2635 2.62545 11.4293 0.796387 8.25017 0.796387C3.7012 0.796387 0.000361231 4.47622 0.000361231 8.99932C0.000361231 10.2285 0.264261 11.4067 0.785124 12.5052L0.0140015 16.3613C-0.0841524 16.8521 0.348869 17.286 0.839826 17.1889L4.74344 16.4171C5.26903 16.6664 5.81277 16.856 6.37146 16.9867C5.11913 11.0552 9.61509 5.48753 15.6184 5.392Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2149 18.5054C23.3496 18.2213 23.4667 17.9318 23.5669 17.6376H23.5412C25.2965 12.4853 21.6051 7.07027 16.1554 6.8066C16.1553 6.80632 16.1553 6.80604 16.1552 6.80576C11.4661 6.58967 7.57031 10.3441 7.57031 14.9995C7.57031 19.5188 11.2434 23.1957 15.7612 23.2023C16.9866 23.2007 18.1612 22.9368 19.2565 22.4173C23.5317 23.2625 23.1983 23.2024 23.2965 23.2024C23.7408 23.2024 24.0727 22.7953 23.986 22.3615L23.2149 18.5054Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.27eef276bea3ff27a72bb60a9ec806a4.svg";
export { ForwardRef as ReactComponent };